import { render, staticRenderFns } from "./NonCompliantProductView.vue?vue&type=template&id=2b0dec99&scoped=true"
import script from "./NonCompliantProductView.vue?vue&type=script&lang=js"
export * from "./NonCompliantProductView.vue?vue&type=script&lang=js"
import style0 from "./NonCompliantProductView.vue?vue&type=style&index=0&id=2b0dec99&prod&scoped=true&lang=css"
import style1 from "./NonCompliantProductView.vue?vue&type=style&index=1&id=2b0dec99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0dec99",
  null
  
)

export default component.exports